module.exports = __webpack_public_path__ + "static/media/guitar-players-herdie.609ea243.svg";